MK.events.on('product:swatch:click', (event = {}) => {
  try {
    let color = event.color || {}
    let product = event.product || {}
    let swatch = event.swatch || {}

    product.color.id = color.color.id
    product.nodes.image.src = color.url.image
    product.nodes.link.href = color.url.product
    product.nodes.imageLink.href = color.url.product
    Object.values(product.nodes.swatches).forEach(swatch => swatch.removeAttribute('class'))
    swatch.className = 'active lazy'
    MK.events.emit('click', product)
  } catch (error) {
    console.log(error)
    console.log('!!! ERROR (swatch.onclick) Error updating swatch after click event.')
    MK.captureException(error)
  }
})